import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VBtn,_vm._g({attrs:{"icon":"","large":"","height":"100","width":"100"},nativeOn:{"click":function($event){return _vm.$emit('set-selected')}}},on),[_c('DiceIcon',{attrs:{"name":_vm.currentSVG,"selected":_vm.dice.selected}})],1)]}}])},[(_vm.dice.selected)?_c('span',[_vm._v("select for next roll")]):_c('span',[_vm._v("take out of next roll")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }